import React from 'react'
import { Link } from 'react-router-dom'
import Icon from './Icons'
import Reveal from './Reveal'
import { products } from '../data/site'

const ProductIdentity = ({ product, detailed }) => {
  if (product.image && detailed) {
    return (
      <div className="relative -mx-6 -mt-6 mb-7 h-40 overflow-hidden border-b border-paper-100/10 bg-[#090b0e] sm:-mx-7 sm:-mt-7">
        <img
          src={product.image}
          alt={`${product.name} logo`}
          className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-[1.035]"
        />
        <span className="absolute bottom-4 left-6 rounded-full border border-paper-100/20 bg-ink-950/75 px-3 py-1 font-sans text-[0.62rem] font-medium uppercase tracking-[0.18em] text-paper-100/70 backdrop-blur-sm sm:left-7">
          Aldaron platform
        </span>
      </div>
    )
  }

  return (
    <span
      className={`relative grid shrink-0 place-items-center overflow-hidden border ${detailed ? 'h-[52px] w-[52px] rounded-[13px]' : 'h-[46px] w-[46px] rounded-full'}`}
      style={{ borderColor: `${product.accent}44`, background: `${product.accent}14`, color: product.accent }}
    >
      {product.image ? (
        <img src={product.image} alt={`${product.name} logo`} className="h-full w-full object-cover" />
      ) : (
        <Icon name={product.icon} className={detailed ? 'h-6 w-6' : 'h-[23px] w-[23px]'} />
      )}
    </span>
  )
}

const ProductCards = ({ detailed = false }) => (
  <div className={`grid ${detailed ? 'gap-5 lg:grid-cols-2' : 'gap-3.5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6'}`}>
    {products.map((product, index) => (
      <Reveal key={product.slug} delay={index * 55}>
        {(() => {
          const ProductLink = product.href ? 'a' : Link
          return <ProductLink
          {...(product.href
            ? { href: product.href, target: '_blank', rel: 'noreferrer' }
            : { to: `/products/${product.slug}` })}
          className={`group relative flex h-full flex-col overflow-hidden border transition-all duration-300 hover:-translate-y-1 ${detailed ? 'rounded-2xl p-6 sm:p-7' : 'rounded-[14px] p-5'}`}
          style={{
            borderColor: `${product.accent}36`,
            background: detailed
              ? `linear-gradient(150deg, ${product.accent}10 0%, #05080f 56%)`
              : `linear-gradient(178deg, ${product.accent}12 0%, ${product.accent}05 32%, #05080f 78%)`,
          }}
        >
          <span
            aria-hidden="true"
            className={`pointer-events-none absolute rounded-full blur-[54px] opacity-30 transition-opacity duration-300 group-hover:opacity-60 ${detailed ? '-right-10 -top-10 h-40 w-40' : '-top-16 left-1/2 h-32 w-32 -translate-x-1/2 blur-[42px] opacity-40 group-hover:opacity-80'}`}
            style={{ background: product.accent }}
          />

          <ProductIdentity product={product} detailed={detailed} />

          <div className={`relative ${product.image && detailed ? '' : detailed ? 'mt-5' : ''}`}>
            <h3
              className={`font-display font-bold tracking-[-0.02em] ${detailed ? 'text-[20px]' : 'mt-5 text-[17px]'}`}
              style={{ color: product.accent }}
            >
              {product.name}
            </h3>
            <p className={`font-medium text-paper-100/85 ${detailed ? 'mt-1 text-[13.5px]' : 'mt-2.5 text-[12.5px] leading-[1.45]'}`}>
              {product.category}
            </p>
          </div>

          <p className={`relative ${detailed ? 'mt-5 text-[14px] leading-[1.7] text-paper-100/55' : 'mt-3 text-[12.5px] leading-[1.6] text-paper-100/48'}`}>
            {detailed ? product.sub : product.description}
          </p>

          {detailed && (
            <ul className="relative mt-5 space-y-2.5">
              {product.highlights.map((item) => (
                <li key={item} className="flex items-start gap-2.5">
                  <span className="mt-[0.38rem] h-1.5 w-1.5 shrink-0 rounded-full" style={{ background: product.accent }} />
                  <span className="text-[13px] leading-[1.6] text-paper-100/62">{item}</span>
                </li>
              ))}
            </ul>
          )}

          <span className={`relative mt-auto flex items-center gap-1.5 font-semibold ${detailed ? 'pt-7 text-[13px]' : 'pt-6 text-[12.5px]'}`} style={{ color: product.accent }}>
            {product.href ? `Visit ${product.name}` : detailed ? `Explore ${product.name}` : 'Learn more'}
            <Icon name="arrow" className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
          </span>
          </ProductLink>
        })()}
      </Reveal>
    ))}
  </div>
)

export default ProductCards
